import axios from 'axios';
import { IAIS } from '../contracts/ais.contract';
import ConfigService from './config.service';

const getByImoNumber = async (imoNumber: string): Promise<IAIS> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/ais/ImoNumber/${imoNumber}`);
    return res.data;
};

const AisService = {
    getByImoNumber
};

export default AisService;
